import React from 'react';
import type { V2Guard, V2Route } from '../units/types';

const card: V2Guard = { kind: 'card' };
const RecipeEditPage = React.lazy(() => import('./RecipeEditPage'));

/**
 * この担当が新UIで作り直した画面の経路。守りは旧画面と同じ:
 * 旧 /ads/recipe-video 系はカード未登録ロックだけ、旧 /chat-v2/edit/:editId は enable_chat_tools だけ。
 */
const routes: V2Route[] = [
  { path: 'ads/recipe-video', Component: React.lazy(() => import('./RecipeListPage')), guard: card },
  { path: 'ads/recipe-video/:projectId', Component: React.lazy(() => import('./RecipeDetailPage')), guard: card },
  { path: 'ads/recipe-video/edit/:editId', Component: RecipeEditPage, guard: card },
  { path: 'chat-v2/edit/:editId', Component: RecipeEditPage, guard: { kind: 'feature', feature: 'enable_chat_tools' } },
];

export default routes;
